import BaseLayout from '@/layout/BaseLayout';
import { trpc } from '@/trpcClient';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@shelflix/ui-web/components/ui/tabs';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { DashboardTab } from './DashboardTab';
import { EventsTab } from './EventsTab';
import { FlowSensorFilter, type FlowSensorFilterValue } from './FlowSensorFilter';
import { SensorsTab } from './SensorsTab';
import { daysAgoBr, todayBr } from './format';
import { useFlowSensorAccess } from './useFlowSensorAccess';

export function FlowSensor() {
  const [tab, setTab] = useState('dashboard');
  const [filter, setFilter] = useState<FlowSensorFilterValue>({
    from: daysAgoBr(6),
    to: todayBr(),
    sensorUuid: 'all',
    facilityUuid: 'all',
  });

  const { canView } = useFlowSensorAccess();
  const sensors = useQuery({ ...trpc.flowSensor.list.queryOptions(), refetchInterval: 60_000, enabled: canView });

  if (!canView) {
    return (
      <BaseLayout>
        <p className="p-4 text-[var(--gray-secondary)]">
          Seu cargo não tem acesso aos sensores de fluxo. Peça ao administrador para liberar em Equipe e Acessos.
        </p>
      </BaseLayout>
    );
  }

  return (
    <BaseLayout>
      <section className="flex w-full flex-col gap-6">
        <Tabs value={tab} onValueChange={setTab} className="w-full">
          <TabsList>
            <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
            <TabsTrigger value="events">Aproximações</TabsTrigger>
            <TabsTrigger value="sensors">Sensores</TabsTrigger>
          </TabsList>
          {tab !== 'sensors' && (
            <div className="mt-4">
              <FlowSensorFilter value={filter} onChange={setFilter} sensors={sensors.data ?? []} />
            </div>
          )}
          <TabsContent value="dashboard" className="mt-4">
            <DashboardTab filter={filter} />
          </TabsContent>
          <TabsContent value="events" className="mt-4">
            <EventsTab filter={filter} />
          </TabsContent>
          <TabsContent value="sensors" className="mt-4">
            <SensorsTab sensors={sensors.data ?? []} isLoading={sensors.isLoading} refetch={() => sensors.refetch()} />
          </TabsContent>
        </Tabs>
      </section>
    </BaseLayout>
  );
}
